import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { CatalogVendeurPublic } from "../../../catalog/catalogTenant";
import { ApiBaseUrl } from "../../http";
import { prepareHeaders } from "../user/user.api";

export const CatalogApi = createApi({
  reducerPath: "catalogApi",
  tagTypes: ["catalogVendeur"],
  baseQuery: fetchBaseQuery({
    baseUrl: `${ApiBaseUrl}/api/`,
    prepareHeaders,
  }),
  endpoints: (builder) => ({
    getCatalogVendeur: builder.query<CatalogVendeurPublic, string>({
      providesTags: (_r, _e, slug) => [{ type: "catalogVendeur", id: slug }],
      query: (shopSlug) => `catalog/${shopSlug}/`,
    }),
  }),
});

export const { useGetCatalogVendeurQuery } = CatalogApi;
